import React from 'react';

const TONES = {
  paid: 'bg-emerald-100 text-emerald-800',
  active: 'bg-emerald-100 text-emerald-800',
  processing: 'bg-sky-100 text-sky-800',
  needs_review: 'bg-amber-100 text-amber-800',
  pending: 'bg-slate-100 text-slate-700',
  initiated: 'bg-slate-100 text-slate-700',
  failed: 'bg-red-100 text-red-700',
  past_due: 'bg-red-100 text-red-700',
  cancelled: 'bg-slate-100 text-slate-500',
  voided: 'bg-slate-100 text-slate-500',
  expired: 'bg-slate-100 text-slate-500',
  refunded: 'bg-violet-100 text-violet-800',
  partially_refunded: 'bg-violet-100 text-violet-800',
  disputed: 'bg-orange-100 text-orange-800',
};

export const StatusPill = ({ status, label, testId }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide whitespace-nowrap ${TONES[status] || 'bg-slate-100 text-slate-600'}`}
    data-testid={testId}>
    {label || (status || '').replace('_', ' ')}
  </span>
);

export const TestModeBanner = () => (
  <div className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-900" data-testid="billing-test-mode-banner">
    TEST MODE: card payments use a simulated gateway in this preview. No real card is charged.
  </div>
);
